import { IContextMenuItem } from '@smartshell/ui-kit';

import { openConfirmDialog } from '../../../services/Confirmation';
import { CtxMenuHost } from '../interfaces';
import { TGetShellItem } from './interfaces';

export const getShellItem: TGetShellItem = ({
  t,
  permissions,
  sendCommand,
  selectedHostsIds,
  sendCommands,
}) => {
  const shellSubMenu: Array<IContextMenuItem<CtxMenuHost>> = [
    {
      key: 'logs',
      text: t('host.ctx.logs'),
      iconName: 'ShareIcon',
      disabled: (host) => !host.online,
      onClick: () => {
        if (!selectedHostsIds) return;
        else if (selectedHostsIds.length === 1) {
          return sendCommand({
            action: 'SEND_LOGS',
            host_id: selectedHostsIds[0],
          });
        } else {
          return sendCommands({
            action: 'SEND_LOGS',
            host_ids: selectedHostsIds,
          });
        }
      },
    },
  ];

  if (permissions?.has('host_manage')) {
    shellSubMenu.push(
      {
        key: 'highAccess',
        text: t('host.ctx.highAccess'),
        disabled: (host: CtxMenuHost) => !host.online || host.locked,
        onClick: ({ id }: CtxMenuHost) => {
          if (!selectedHostsIds?.length) {
            return sendCommand({
              host_id: id,
              action: 'ALLOW_ADMIN_MODE',
            });
          } else if (selectedHostsIds.length === 1) {
            return sendCommand({
              action: 'ALLOW_ADMIN_MODE',
              host_id: selectedHostsIds[0],
            });
          } else {
            return sendCommands({
              action: 'ALLOW_ADMIN_MODE',
              host_ids: selectedHostsIds,
            });
          }
        },
      },
      {
        key: 'disableShell',
        text: t('host.ctx.shell.disable'),
        disabled: (host: CtxMenuHost) => !host.online || host.locked,
        onClick: ({ id, client_sessions, alias }: CtxMenuHost) => {
          const host_id = selectedHostsIds?.[0] || id;

          if (selectedHostsIds && selectedHostsIds.length > 1) {
            return sendCommands({
              host_ids: selectedHostsIds,
              action: 'DISABLE_SHELL',
            });
          } else if (client_sessions.length) {
            return openConfirmDialog(t, 'remove', {
              title: t('notifyService.shell_remove.title'),
              message: t('notifyService.shell_remove.description', alias),
              acceptTitle: t('notifyService.shell_remove.accept'),
            }).then(({ status }) => {
              if (status === 'ACCEPTED') {
                return sendCommand({
                  host_id: host_id,
                  action: 'DISABLE_SHELL',
                });
              }
            });
          } else {
            return sendCommand({ host_id: host_id, action: 'DISABLE_SHELL' });
          }
        },
      }
    );
  }

  return !permissions?.has('host_command_manage')
    ? null
    : {
        key: 'shell',
        text: t('host.ctx.shell'),
        iconName: 'ShellIcon',
        subMenu: shellSubMenu,
      };
};
